/**
 *
 * App
 *
 */
import * as React from 'react';
import { clarity } from 'react-microsoft-clarity';
import jwtDecode from 'jwt-decode';

import { createRouter, BaseRouter } from 'lib/router';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { GlobalStyle } from 'styles/global-styles';

import routes from './routes';

import { LoaderDots } from 'app/components/LoaderDots';
import { ErrorFallback } from 'app/components/ErrorFallback';

interface User {
  user_id: string;
}

const router = createRouter(routes as any, {
  defaultFallback: <LoaderDots />,
  errorFallback: ErrorFallback,
});

const clarityInit = (): void => {
  const token = window.localStorage.getItem('token') ?? '';
  try {
    const user: User | null = token ? jwtDecode<{ user_id: string }>(token) : null;

    if (user?.user_id) {
      clarity.init('gtxwqrpnzs');
      if (clarity.hasStarted() && user?.user_id) {
        clarity.identify(user.user_id, user);
      }
    }
  } catch (e) {
    // TODO: Capture with sentry
    console.error(e);
  }
};

const App = () => {
  /**
   * State
   */
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY || '');

  /**
   * Lifecycle
   */
  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      clarityInit();
    }
  }, []);

  return (
    <>
      <Elements stripe={stripePromise}>
        <BaseRouter router={router} />
      </Elements>
      <GlobalStyle />
    </>
  );
};

export default App;
